(function(){
  if (window.__lmx) return; window.__lmx = true;
  var GIFT_TAG_PROP = '_free_gift';
  function refresh(cart){
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'lmx', data: { itemCount: cart ? cart.item_count : 0 } } }));
    document.querySelectorAll('.lm-hdr__bag-count').forEach(function(b){ if (cart) b.textContent = cart.item_count || ''; });
  }
  function getCart(){ return fetch('/cart.js', { headers: { accept: 'application/json' } }).then(function(r){ return r.json(); }); }
  function isGift(i){ return (i.properties && i.properties[GIFT_TAG_PROP]) || i.handle === 'mystery-bikini-set'; }
  var busy = false;
  // Keep the free gift honest: max one, and only alongside a paid item.
  function guard(){
    if (busy) return; busy = true;
    getCart().then(function(cart){
      var gifts = cart.items.filter(isGift), paid = cart.items.filter(function(i){ return !isGift(i); });
      var updates = {};
      gifts.forEach(function(g, n){
        var want = (paid.length && n === 0) ? 1 : 0;
        if (g.quantity !== want) updates[g.key] = want;
      });
      if (!Object.keys(updates).length) { busy = false; return; }
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function(r){ return r.json(); }).then(function(c){ busy = false; refresh(c); });
    }).catch(function(){ busy = false; });
  }
  document.addEventListener('submit', function(e){
    var f = e.target.closest && e.target.closest('[data-lmx-add]'); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button[type=submit]'); if (btn) { btn.disabled = true; btn.dataset.t = btn.textContent; btn.textContent = '…'; }
    var fd = new FormData(f); fd.append('quantity', '1');
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { accept: 'application/json' } })
      .then(function(r){ if (!r.ok) throw r; return getCart(); })
      .then(function(cart){ refresh(cart); })
      .catch(function(){ if (btn) btn.textContent = 'Sold out'; })
      .finally(function(){ if (btn) { btn.disabled = false; setTimeout(function(){ if (btn.textContent !== 'Sold out') btn.textContent = btn.dataset.t; }, 50); } });
  });
  document.addEventListener('cart:update', function(e){ if (e.detail && e.detail.sourceId === 'lmx') return; setTimeout(guard, 400); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard); else guard();
})();
